var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9688 3.59375H18.8466V5.03125H18.9688C19.1594 5.03125 19.3422 5.10698 19.477 5.24177C19.6118 5.37656 19.6875 5.55938 19.6875 5.75V20.125C19.6875 20.3156 19.6118 20.4984 19.477 20.6332C19.3422 20.768 19.1594 20.8438 18.9688 20.8438H6.03125C5.84063 20.8438 5.65781 20.768 5.52302 20.6332C5.38823 20.4984 5.3125 20.3156 5.3125 20.125V5.75C5.3125 5.55938 5.38823 5.37656 5.52302 5.24177C5.65781 5.10698 5.84063 5.03125 6.03125 5.03125H6.15344V3.59375H6.03125C5.45938 3.59375 4.91093 3.82093 4.50655 4.2253C4.10218 4.62968 3.875 5.17813 3.875 5.75V20.125C3.875 20.6969 4.10218 21.2453 4.50655 21.6497C4.91093 22.0541 5.45938 22.2812 6.03125 22.2812H18.9688C19.5406 22.2812 20.0891 22.0541 20.4935 21.6497C20.8978 21.2453 21.125 20.6969 21.125 20.125V5.75C21.125 5.17813 20.8978 4.62968 20.4935 4.2253C20.0891 3.82093 19.5406 3.59375 18.9688 3.59375Z",
    fill: "#8F95B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5312 2.15625H15.375V0H9.625V2.15625H7.46875V6.46875H17.5312V2.15625ZM16.0938 5.03125H8.90625V3.59375H11.0625V1.4375H13.9375V3.59375H16.0938V5.03125Z",
    fill: "#8F95B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1875 9.34375H16.8125V10.7812H8.1875V9.34375ZM8.1875 12.9375H16.8125V14.375H8.1875V12.9375ZM8.1875 16.5312H16.8125V17.9688H8.1875V16.5312Z",
    fill: "#8F95B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.51e10be6ca8030c25b89d391700f63e0.svg";
export { ForwardRef as ReactComponent };